export const wave = (fill = "#43D6B9") => {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.508 3.413"><path fill="${fill}" d="M11.508 0C9.89 0 9.054.709 8.316 1.335c-.699.592-1.302 1.103-2.562 1.103-1.26 0-1.863-.511-2.562-1.103C2.454.709 1.617 0 0 0v.975c1.26 0 1.863.511 2.562 1.103.738.626 1.574 1.335 3.192 1.335s2.454-.709 3.192-1.335c.699-.592 1.302-1.103 2.561-1.103L11.508 0z"/></svg>`;
};

export const bullet = (fill = "#43D6B9") => {
  return `<svg width="36" height="7" viewBox="0 0 36 7" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 1c5.883 0 5.883 5 11.767 5 5.883 0 5.883-5 11.767-5 5.883 0 5.883 5 11.765 5" fill="none" stroke="${fill}" stroke-width="2"/>
  </svg>`;
};
